FiltersMdl.directive( "colorFan", ['$templateCache', 'UtilsSrv', function( $templateCache, UtilsSrv ) {
	return {
		restrict: 'E',
		replace: true,
		template: $templateCache.get('Filters/Color-Fans/Templates/_color-fan.tpl.html'),
		link: function( scope, element ) {


				//element.on('click', function(e){
				//
				//});

					//console.log(element)

			//$timeout(function () {
			//	element.on('click', function(){
			//		console.log('fff')
			//		//UtilsSrv.scrollHandler.scrollToFans();
			//	})
			//});

		}
	}
}]);
